import React from "react"
import styled from "styled-components"

import { QuorumTheme } from "app/static/frontend/design-constants"

const Container = styled.div`
    padding: 2rem 1.5rem;
    height: 100%;
    width: 100%;

    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
`

const Title = styled.h2`
    color: ${QuorumTheme.colors.gray[9]};
    text-align: center;
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 140%;

    margin: 0;
`

const Subtitle = styled.p`
    color: ${QuorumTheme.colors.gray[7]};
    text-align: center;
    font-size: 1rem;
    font-weight: 400;
    line-height: 150%;

    margin: 0;
`

// Awful stopgap to satisfy big G while we wait for a full Search rebuild. Delete me ASAP.
export const MobileEmptyState = () => {
    return (
        <Container>
            <img src="https://static.quorum.us/global/common/images/search-illustration.svg" alt="Magnifying Glass" />
            <div>
                <Title>No results found</Title>
                <Subtitle>Try using different terms and search again</Subtitle>
            </div>
        </Container>
    )
}
